import { render } from "./nopermision.vue?vue&type=template&id=3063dbde&scoped=true"
import script from "./nopermision.vue?vue&type=script&lang=js"
export * from "./nopermision.vue?vue&type=script&lang=js"

import "./nopermision.vue?vue&type=style&index=0&id=3063dbde&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3063dbde"]])

export default __exports__